import styled from 'styled-components';
import { Modal } from '@amzn/storm-ui';

export const Wrapper = styled.div`
  position: relative;
  width: 300px;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.small.default};
`;

export const TriggerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  input {
    pointer-events: none;
  }
`;

export const SearchContainer = styled.div`
  width: 400px;
  height: 248px;
`;

export const ResultsContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.small.default};
`;

export const SearchModal = styled(Modal)`
  align-items: flex-start;
  padding-top: ${({ theme }) => theme.spacing.xxlarge.default};
`;
